// extracted by mini-css-extract-plugin
var _1 = "EditFacesMagneticWall-module__animateUploadProgressBarWidth--dArKv";
var _2 = "EditFacesMagneticWall-module__animatedBackground--nIioo";
var _3 = "EditFacesMagneticWall-module__avatarButton--IKIjW";
var _4 = "EditFacesMagneticWall-module__avatarContainer--t4Wxc";
var _5 = "22px";
var _6 = "EditFacesMagneticWall-module__container--n9fRX";
var _7 = "EditFacesMagneticWall-module__hasHoveredBlot--gdN7R";
var _8 = "EditFacesMagneticWall-module__isFocused--Do8Lz";
var _9 = "EditFacesMagneticWall-module__isInBackground--qM2zE";
var _a = "EditFacesMagneticWall-module__tooltipContainer--rItz4";
var _b = "EditFacesMagneticWall-module__tooltipName--bYcHp";
var _c = "EditFacesMagneticWall-module__tooltipTitle--BjrLV";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarButton", _4 as "avatarContainer", _5 as "avatarSize", _6 as "container", _7 as "hasHoveredBlot", _8 as "isFocused", _9 as "isInBackground", _a as "tooltipContainer", _b as "tooltipName", _c as "tooltipTitle" }
